import { render } from "./FourthStep.vue?vue&type=template&id=64be96af&scoped=true"
import script from "./FourthStep.vue?vue&type=script&lang=js"
export * from "./FourthStep.vue?vue&type=script&lang=js"

import "./FourthStep.vue?vue&type=style&index=0&id=64be96af&lang=scss&scoped=true"

import exportComponent from "D:\\LTG Sercices\\SUP-H\\suph-adhesion-pro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64be96af"]])

export default __exports__